import { Avatar, styled } from "@material-ui/core"

export const StyledAvatar = styled(Avatar)({
  height: 50,
  width: 50
})
